import { render, staticRenderFns } from "./WarehouseTransferAttentionModal.vue?vue&type=template&id=63c301a9"
import script from "./WarehouseTransferAttentionModal.vue?vue&type=script&lang=js"
export * from "./WarehouseTransferAttentionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports